// CRM Sales Teams — crm_teams.* (menu_item_id 45, CRM)
//
// The named groups a lead or a deal can be assigned to. Registered by the amer-laravel
// migration 2026_08_12_000003_add_crm_team_permissions. The ids are the approval numbers
// the central permission-key registry assigned — not a range reserved here. They are not
// contiguous with the CRM keys above them, which is normal: the registry hands out the
// next free numbers across every tenant app, so never infer an id from its neighbours.
//
// There is deliberately no `crm_teams.assign` key: handing a lead to a team is the same act
// as handing it to a person, so it rides on leads.assign_agent / deals.assign_agent.

/** crm_teams.index — also gates the team picker inside the assign dialog. */
export const CRM_TEAMS_INDEX = 1460;
/** crm_teams.store */
export const CRM_TEAMS_STORE = 1461;
/** crm_teams.update */
export const CRM_TEAMS_UPDATE = 1462;
/** crm_teams.destroy */
export const CRM_TEAMS_DESTROY = 1463;
